import React, {useEffect, useState, startTransition} from "react";
import {GoogleMap, useJsApiLoader, Marker, TrafficLayer} from '@react-google-maps/api';
import axios from "axios";
import {Typography, Box, Grid} from "@mui/material";
import {TextDecrypt} from "../content/TextDecrypt";
import styles from "../../MapG.module.css"
import "../../mapG.css"

const containerStyle = {
    // width: '500px',
    // height: '400px',
    borderRadius: "20px",
    transition: "all 0.25s ease-out",
};


const mapStyles = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#1d2c4d"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#8ec3b9"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1a3646"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#4b6878"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#64779e"
            }
        ]
    },
    {
        "featureType": "administrative.province",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#4b6878"
            }
        ]
    },
    {
        "featureType": "landscape.man_made",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#334e87"
            }
        ]
    },
    {
        "featureType": "landscape.natural",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#023e58"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#283d6a"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#6f9ba5"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1d2c4d"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#023e58"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#3C7680"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#304a7d"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#98a5be"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1d2c4d"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#2c6675"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#255763"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#b0d5ce"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#023e58"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#98a5be"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#1d2c4d"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#283d6a"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#3a4762"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#0e1626"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#4e6d70"
            }
        ]
    }
];

const MapData = () => {
    const [first, setFirst] = useState(true);
    const [het, setHet] = useState();
    const [fullData, setFullData] = useState();
    const [map, setMap] = useState(null);
    const [ips, setIps] = useState();
    const [cll, setCall] = useState(false);
    const {isLoaded} = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyDZfVO29Iytspv4xz7S68doIoiztiRLhbk" || "AIzaSyDRrJEBeG7mEpPByROXN1wEQdkT2I0eHVI"
    })
    // googleMapsApiKey: "AIzaSyDZfVO29Iytspv4xz7S68doIoiztiRLhbk" || "AIzaSyDRrJEBeG7mEpPByROXN1wEQdkT2I0eHVI"
    const OPTIONS = {
        // zoom: 14,
        minZoom: 1,
        maxZoom: 12,
        // mapTypeId: "satellite",
        zoomControl: false,
        styles: {borderRadius: "16px", mapStyles},
        streetViewControl: false,
        // scrollwheel: false,
        // gestureHandling: 'none',
        disableDefaultUI: true
    }
    // mapTypeId: satellite || "hybrid"

    useEffect(async () => {
        if (first) {
            let ip
            setFirst(!first)
            await axios.get("https://ipapi.co/json/")
                .then(res => {
                    setFullData(res.data)
                    setCall(true)
                })
                .catch(err => console.log("api.ipify", err))
            //  await axios.get(`https://ip-api.com/json/${ip}`)
            // await axios.get("https://ip2c.org/self")
        }
    }, [])

    // useEffect(() => {
    // await axios.post(`${process.env.REACT_APP_PATH}/portfolio/ipsdata`, {ip: ips})
    // }, [ips, cll])

        //     await axios.get("https://api.ipify.org?format=json")

        //             await axios.get(`http://ip-api.com/json/${res.data.ip}`)

        //     await axios.get(`http://ip-api.com/json/${ip}`)

        //         await axios.post(`${process.env.REACT_APP_PATH}/portfolio/ipsdata`, {ip: ips})


    const center = {
        lat: fullData ? fullData.latitude : 21.2172,
        lng: fullData ? fullData.longitude : 72.8498
    };
    // const center = {
    //     lat: 21.2172,
    //     lng: 72.8498
    // };
    const onLoad = React.useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(center);
        map.fitBounds(bounds);
        setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    return (
        <>
            <div className="__map_wrapper" style={{backdropFilter: "blur(10px)"}} >
                {isLoaded ? (
                    <GoogleMap
                        id="GoogleMap"
                        draggable
                        editable
                        clickableIcons
                        defaultMotionTracking
                        options={OPTIONS}
                        mapContainerStyle={containerStyle}
                        center={center}
                        // zoom={12}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                    >
                        <Marker
                            position={center}
                        />
                        {/*<TrafficLayer autoUpdate/>*/}
                    </GoogleMap>
                ) : <></>}

                {fullData && <Box className={styles.userData}>
                    <Grid container rowSpacing={1} columnSpacing={{xs: 0, sm: 0, md: 0}}>
                        <Grid item lg={6} xs={12}>
                            <Typography className={styles.key}>
                                Country: <TextDecrypt text={fullData && fullData.country_name}/>
                            </Typography>
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <Typography className={styles.key}>
                                State: <TextDecrypt text={fullData && fullData.region}/>
                            </Typography>
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <Typography className={styles.key}>
                                City: <TextDecrypt text={fullData && fullData.city}/>
                            </Typography>
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <Typography className={styles.key}>
                                Timezone: <TextDecrypt text={fullData && fullData.timezone}/>
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>}
            </div>
        </>
    );
};

export default MapData;

// "AIzaSyDZfVO29Iytspv4xz7S68doIoiztiRLhbk" || "AIzaSyDRrJEBeG7mEpPByROXN1wEQdkT2I0eHVI"